import { Pipe, PipeTransform } from '@angular/core';
import { LocalDateTime } from '../types/local-date-time.type';

@Pipe({
	name: 'displayLocalTimeWithoutSeconds'
})
export class DisplayLocalTimeWithoutSecondsPipe implements PipeTransform {
	transform(localTime: LocalDateTime | null | undefined): string | undefined {
		if (!localTime)
			return undefined;
		
		const year = localTime[0];
		const month = localTime[1];
		const day = localTime[2];
		const hour = localTime[3];
		const min = localTime[4];
		
		return this.pad(day) + '/' + this.pad(month) + '/' + year + ' ' + this.pad(hour) + ':' + this.pad(min);
	}
	
	private pad(value: number): string {
		return (value < 10 ? "0" : "") + value;
	}
}